import { Link } from "react-router-dom";
import NewsCard from "@/components/feature/NewsCard";
import { getPopularComics, getSortedNews } from "@/utils/comic";

export default function NewsSidebar() {
  const news = getSortedNews().slice(0, 6);
  const ranking = getPopularComics(5);

  return (
    <aside className="flex flex-col gap-6">
      <div className="rounded-lg bg-background-50 border border-background-200 p-4 md:p-5">
        <div className="flex items-center justify-between mb-3">
          <h2 className="text-base md:text-lg font-label font-bold text-foreground-950 flex items-center gap-2">
            <span className="w-7 h-7 flex items-center justify-center rounded-md bg-accent-100">
              <i className="ri-flashlight-line text-accent-700"></i>
            </span>
            实时资讯
          </h2>
          <Link
            to="/news"
            className="text-xs font-label font-bold text-primary-600 hover:text-primary-700 whitespace-nowrap"
          >
            全部 &gt;
          </Link>
        </div>

        {news.length === 0 ? (
          <p className="py-8 text-center text-sm text-foreground-500">
            暂无相关内容，稍后再来看看吧
          </p>
        ) : (
          <div className="flex flex-col">
            {news.map((item) => (
              <NewsCard key={item.id} news={item} />
            ))}
          </div>
        )}
      </div>

      <div className="rounded-lg bg-background-100 border border-background-200 p-4 md:p-5">
        <div className="flex items-center justify-between mb-3">
          <h2 className="text-base md:text-lg font-label font-bold text-foreground-950 flex items-center gap-2">
            <span className="w-7 h-7 flex items-center justify-center rounded-md bg-secondary-100">
              <i className="ri-fire-line text-secondary-700"></i>
            </span>
            人气排行榜
          </h2>
        </div>
        <ol className="flex flex-col">
          {ranking.map((comic, index) => (
            <li key={comic.id}>
              <Link
                to={`/comic/${comic.id}`}
                className="group flex items-center gap-3 py-2 border-b border-background-200 last:border-b-0"
              >
                <span
                  className={`w-6 h-6 shrink-0 flex items-center justify-center rounded-md text-xs font-label font-bold ${
                    index < 3
                      ? "bg-accent-500 text-accent-950"
                      : "bg-background-200 text-foreground-700"
                  }`}
                >
                  {index + 1}
                </span>
                <span className="flex-1 text-sm text-foreground-800 line-clamp-1 group-hover:text-primary-600 transition-colors">
                  {comic.title}
                </span>
                <span className="text-xs text-foreground-500 shrink-0">
                  {comic.views}
                </span>
              </Link>
            </li>
          ))}
        </ol>
      </div>
    </aside>
  );
}